import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

export default function AboutUsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="relative min-h-[400px] flex items-center bg-cover bg-center" style={{ backgroundImage: 'url(https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/be2cafd0cba39437049d5eb2d00be088.jpeg)' }}>
          <div className="absolute inset-0 bg-black/60"></div>
          <div className="relative max-w-7xl mx-auto px-6 py-20 text-white">
            <h2 className="text-5xl font-bold mb-4">About Milajet Havacilik</h2>
            <p className="text-xl text-white/90">
              Milajet Havacilik provides premier private jet services, specializing in luxury air travel across Europe, Africa, the Middle East, and Asia.
            </p>
          </div>
        </section>

        {/* Our Journey Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <img
                  src="https://static.readdy.ai/image/260cb4a7e92398667a2a2f5c835f3622/036e19a2701002dfa08cbc2b81c18f6c.jpeg"
                  alt="Private Jet"
                  className="w-full rounded-lg shadow-lg"
                />
              </div>
              <div>
                <h2 className="text-4xl font-bold mb-6">Our Journey to Excellence</h2>
                <p className="text-gray-600 mb-8">
                  Milajet Havacilik has been at the forefront of private aviation, offering unparalleled luxury and safety since its inception. Our mission is to provide seamless, personalized jet experiences across Europe, Africa, the Middle East, and Asia, ensuring every client travels in comfort and style. Our core values include safety, exclusivity, and customer satisfaction, which drive us to deliver exceptional service on every flight.
                </p>

                <div className="grid grid-cols-2 gap-8">
                  <div>
                    <div className="text-4xl font-bold text-blue-600 mb-2">150k</div>
                    <div className="text-gray-600">Flights Completed</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-blue-600 mb-2">50k</div>
                    <div className="text-gray-600">Satisfied Clients</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-blue-600 mb-2">200k</div>
                    <div className="text-gray-600">Hours Flown</div>
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-blue-600 mb-2">3000h</div>
                    <div className="text-gray-600">Total Flight Hours</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
